// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sb_sub-grid[data-v-0bbd401d], .sb_split-grid[data-v-0bbd401d] {\n    height: 100%;\n    width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
